import { render, staticRenderFns } from "./animation.vue?vue&type=template&id=390b7054&scoped=true&"
import script from "./animation.vue?vue&type=script&lang=js&"
export * from "./animation.vue?vue&type=script&lang=js&"
import style0 from "./animation.vue?vue&type=style&index=0&id=390b7054&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390b7054",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('390b7054')) {
      api.createRecord('390b7054', component.options)
    } else {
      api.reload('390b7054', component.options)
    }
    module.hot.accept("./animation.vue?vue&type=template&id=390b7054&scoped=true&", function () {
      api.rerender('390b7054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/upgrade2/detail/components/animation.vue"
export default component.exports